/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
// libraries
import React from 'react';
import {
    object, shape, string,
} from 'prop-types';
import { UIDReset, UIDConsumer } from 'react-uid';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';

// components
import MasterTemplatePageBlock from './Partials/MasterTemplatePageBlock';
import MasterTemplateLeftRail from './Partials/MasterTemplateLeftRail';

const styles = ()  => ({
    bannerBlock: {
        width: '100%',
        margin: '10px 0',
        '& img': {
            width: '100%',
        },
        '& a': {
            width: '100%',
            display: 'block',
        },
    },
    leftRailStyle: {
        paddingRight: '20px',
    },
    masterPageStyle: {
        maxWidth: '1400px',
        width: '100%',
        margin: '0 auto',
    },
});

const TemplateMasterPage = ({
    classes, block, ssrDeviceType, brand,
}) => {
    const showLeftRailContent = block.some((blocks) => ((blocks.related_articles || blocks.related_searches || blocks.side_rail_banner)));
    const setGrid = showLeftRailContent ? 9 : 12;

    return (
        <Grid container className={classes.masterPageStyle}>
            {
                showLeftRailContent
            && (

                <Grid item xs={3} className={classes.leftRailStyle}>
                    <UIDReset>
                        <UIDConsumer>
                            {(id, uid) => block.map(
                                (blocks) => (
                                    <MasterTemplateLeftRail
                                        brand={brand}
                                        block={blocks}
                                        key={uid(blocks)}
                                        ssrDeviceType={ssrDeviceType}
                                    />
                                ),
                            )}
                        </UIDConsumer>
                    </UIDReset>
                </Grid>
            )
            }
            <Grid item xs={setGrid}>
                <UIDReset>
                    <UIDConsumer>
                        {(id, uid) => block.map(
                            (blocks) => (
                                <MasterTemplatePageBlock
                                    brand={brand}
                                    block={blocks}
                                    key={uid(blocks)}
                                    ssrDeviceType={ssrDeviceType}
                                />
                            ),
                        )}
                    </UIDConsumer>
                </UIDReset>
            </Grid>
        </Grid>
    );
};

TemplateMasterPage.propTypes = {
    classes: object.isRequired,
    block: object.isRequired,
    brand: shape({
        code: string,
    }).isRequired,
    ssrDeviceType: string.isRequired,
};

export default withStyles(styles)(TemplateMasterPage);
